import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import DrawerToggle from '../../components/Navigation/SideDrawer/DrawerToggle/DrawerToggle';



import classes from './Header.css';

class Header extends Component {
    state = {
        authenticated: true
    }


    render() {
        return (
            <div className={classes.Header}>
                <div className={classes.MenuToggle}>
                    <DrawerToggle clicked={this.props.open}/>
                </div>
                <h1 className={classes.Title}>
                    <Link to="/" className={classes.Link}>
                        Dibs-it
                    </Link>
                </h1>
            </div>
        )
    }



}

export default Header;


// WEBPACK FOOTER //
// ./src/containers/Header/Header.js